export const locale = {
  lang: 'pt',
  data: {
    'ALERTS':{
      'OK':'OK'
    },
    'FOCUS':{
      'GRUPOS':{
        'ADMIN': 'Administrador de grupos',
        'CREAR': 'Crear grupo',
        'EDITAR': 'Editar Grupo',
        'APLICAR': 'Aplicar',
        'NAME':'Nombre del grupo',
        'DESCRIPCION': 'Descripción',
        'FILTROS': 'Filtros',
        'ACCION': 'Acciones',
        'EDIT': 'Editar',
        'DELETE': 'Eliminar'
      },
      'CREAR': {
        'DATO': 'Datos del grupo',
        'NAME': 'Nombre del grupo',
        'DESCRIPCION': 'Descripción del grupo',
        'FILTROS': 'Filtros',
        'FILSELEC': 'Filtros seleccionados',
        'COUNTRY': 'País',
        'CARGO': 'Cargo y/o función',
        'ANTIG': 'Antiguedad',
        'GENDER': 'Género'
      },
      'REACTIVOS': {
        'SIN': 'Aún no ha realizado la selección de reactivos',
        'STEPS': {
          '1': {
              'TITULO': 'Selección de reactivos',
              'DISPONIBLES': 'Plantillas disponibles:',
              'LISTADO': {
                'TITULO': 'Construya la lista de reactivos que desee visualizar en la encuesta',
                'SUBTITULO': 'Elija una plantilla de la lista para mostrar su listado de reactivos',
                'PICKEDTITU': 'Lista de reactivos de la plantilla: ',
                'PICKEDTOT': 'Reactivos disponibles: ',
                'PICKEDNUM': 'Reactivos seleccionados: ',
              }
          },
          '2': {
              'TITULO': 'Traducciones'
          },
          '3': {
              'TITULO': 'Previsualización',
              'TEXTOS': {
                'es': {
                  'EMPRESA': 'Responde pensando en tu empresa y en todos los líderes',
                  'AREA': 'Responde pensando en tu área de trabajo y tu líder directo',
                  'BOTONES': {
                    '0': 'Casi siempre es falso',
                    '1': 'Frecuentemente es falso',
                    '2': 'A veces es falso / A veces es verdad',
                    '3': 'Frecuentemente es verdad',
                    '4': 'Casi siempre es verdad'
                  }
                },
                'en': {
                  'EMPRESA': 'Organization Perspective',
                  'AREA': 'Workgroup Perspective',
                  'BOTONES': {
                    '0': 'It is almost always false',
                    '1': 'It is often false',
                    '2': 'Sometimes it´s fake / Sometimes it´s true',
                    '3': 'It is often true',
                    '4': 'It is almost always true'
                  }
                },
                'pt': {
                  'EMPRESA': 'Perspectiva da organização',
                  'AREA': 'Perspectiva do grupo de trabalho',
                  'BOTONES': {
                    '0': 'Quase sempre é falso',
                    '1': 'É frequentemente falso',
                    '2': 'Às vezes é falso / às vezes é verdade',
                    '3': 'É frequentemente verdade',
                    '4': 'Quase sempre é verdade'
                  }
                },
              }
            }
          }
        }
    },
    'CERTIFICAR': {
      'IDIOMAS': {
        'ELEGIR': 'Escolher',
        'STATUS': {
          'PEND': 'Etapa completa',
          'DONE': 'Etapa concluída'
        },
        'MENSAJES':{
          'ADDLANG': 'Idioma adicionado ',
          'NOADITIONAL': 'A opção foi escolhida sem idiomas adicionais',
          'ERRORADD': 'Ocorreu um erro ao adicionar o idioma',
          'LANGDEL': 'Idioma removido ',
          'NOADITIONALDEL': 'Seleção cancelada sem idiomas adicionais',
          'ERRORDEL': 'Ocorreu um erro ao excluir o idioma',
          'MAINPICKED': 'Você já escolheu o idioma nativo para a pesquisa. <br> <br> Para alterá-lo, remova o idioma selecionado e escolha o novo idioma'
        },
        'CARD1': {
          'TITULO': 'Primeiro idioma',
          'ACCION': {
            'PRE': 'Você não selecionou o idioma principal',
            'POST': 'Você selecionou o idioma: '
          },
          'MODAL': {
            'TITULO': 'Escolha o idioma principal',
            'ACCION': 'Qual é o idioma principal da pesquisa?',
            'PLACELISTA': 'Selecione um idioma',
            'BOTONES': {
              'BACK': 'Para retornar',
              'OK': 'pronto'
            }
          }
        },
        'CARD2': {
          'TITULO': 'Idiomas Adicionais',
          'ACCION': {
            'PRE': 'Você não selecionou idiomas adicionais',
            'SINADIC': 'A pesquisa não terá idiomas adicionais',
            'POST': 'Você selecionou os idiomas: '
          },
          'MODAL': {
            'TITULO': 'Escolha idiomas adicionais',
            'ACCION': 'Quais idiomas adicionais você deseja adicionar à pesquisa?',
            'BOTONES': {
              'BACK': 'Para retornar',
              'OK': 'pronto'
            }
          }
        }
      },
      'NPS': {
        'CONFIGURE_QUESTION': 'Clique aqui para visualizar o NPS',
        'ADD': 'Crie uma pergunta:',
        'QUESTIONUPDATEDOK': 'NPS atualizado com sucesso',
        'STATUS': {
          'PEND': 'Etapa completa',

          'DONE': 'Etapa concluída'
        },
        'TABS': {
          'TAB1': 'NPS',
          'TAB2': 'Tradução',
          'TAB3': 'Pré-visualização',
        }
      },

      'REACTIVOS': {
        'CONFIGURE_QUESTION': 'Clique aqui para ver o reagente',
        'ADD': 'Crie uma pergunta:',
        'QUESTIONUPDATEDOK': 'Reagente atualizado com sucesso',
        'STATUS': {
          'PEND': 'Etapa completa',

          'DONE': 'Etapa concluída'
        },
        'TABS': {
          'TAB1': 'Reagentes',
          'TAB2': 'Tradução',
          'TAB3': 'Pré-visualização',
        }
      },
      'CONTROL': {
        'CONFIGURE_QUESTION': 'Clique aqui para visualizar a pergunta de controle',
        'ADD': 'Crie uma pergunta:',
        'QUESTIONUPDATEDOK': 'Pergunta de controle atualizada com sucesso',
        'STATUS': {
          'PEND': 'Etapa completa',

          'DONE': 'Etapa concluída'
        },
        'TABS': {
          'TAB1': 'Pergunta de controle',
          'TAB2': 'Tradução',
          'TAB3': 'Pré-visualização',
        }
      },
      'DEMOGRAFICOS': {
        'NOINFO':'Sem informação disponível',
        'TAB1': 'Demográfico',
        'TAB2': 'Tradução',
        'TAB3': 'Pré-visualização',
        'COMPLETAR_PASO': 'Etapa completa',
        'PASO_COMPLETADO': 'Etapa concluída',
        'SELECT': 'Selecione uma opção',
        'BTN_DEMOGRAFICOS': 'Aceitar',
        'OPTION_SURVEY': 'Pesquisa',
        'OPTION_EXCEL': 'Excel',
        'OPTION_AMBOS': 'Ambos',
        'CLAVE': 'Chave',
        'RESPONSE_NOT_ADDED': 'Não foi possível adicionar respostas a uma pergunta aberta',
        'CONFIGURE_QUESTION': 'Clique aqui para ver a pergunta',
        'QUESTION': 'Questão',
        'OPCIONES_RESPUESTA': 'Opções de resposta',
        'STATUS': {
          'PEND': 'Etapa completa',
          'DONE': 'Etapa concluída'
        },
        'EXPANSION':{
          'Work Responsability' : 'Responsabilidade de trabalho',
          'Trust Level' : 'Nível de confiança',
          'Innovation' : 'Inovação',
          'Disabilities' : 'Deficiências',
          'Ethnic Group' : 'Grupo étnico',
          'Personal Responsabilities' : 'Responsabilidades pessoais',
          'Gender' : 'Gênero',
          'Work Location' : 'Local de trabalho',
          'Travel' : 'Viagem',
          'Living Location' : 'Lugar de residência',
          'Marital Status' : 'Estado civil',
          'Home Type' : 'Tipo de residência',
          'Home Location' : 'Localização da casa',
          'Home Status' : 'Status inicial',
          'Transport' : 'Transporte',
          'Sports' : 'Esportes',
          'Weight' : 'Peso',
          'Sleep' : 'Dormir',
          'Home Office' : 'Trabalho em casa',
          'Languages' : 'línguas',
          'Work Experience' : 'Experiência de trabalho',
          'Social Networks' : 'Redes sociais',
          'Employ Opportunities' : 'Oportunidades de emprego',
          'Inspiration' : 'Inspiração',
          'Meetings' : 'Encontros',
          'Tenure' : 'Posse',
          'Clave': 'Chave',
          'Ege': 'Geração',
          'Work Status': 'Status de trabalho',
          'Education': 'Educação',
          'Hierarchical Level': 'Nível hierárquico',
          'Confidence Decisions': 'Decisões de confiança',
          'Work Innovation': 'Inovação no trabalho',
          'Belong': 'Pertencer',
          'Converse Performance': 'Frequência de reunião',
          'Work Years':'Anos de trabalho',
          'Generation':'Geração',
          'Confidence In Decisions': 'Confiança nas decisões',
          'Develop New Things': 'Desenvolver coisas novas',
          'Reason To Stay':'Razão para ficar',
          'Age':'Era',
          'Type Of Job':'Tipo de trabalho',
          'Minoritate':'Minoria',
          'Sindicat':'Sindicato',
          //TURQUIA//
          'Confidence':'Confiar em',
          'Opportunities':'Oportunidades',
          'Managerial Level':'Nível de gerenciamento',
          'Years Of Service':'Anos de serviço',
          'Ethnic':'Étnico',
          //BRASIL
          'Permanência':'Permanência',
          'Reuniões':'Reuniões',
          'Motivo para ficar':'Motivo para ficar',
          'Casa':'Casa',
          'Nível de confiança':'Nível de confiança',
          'Oportunidades':'Oportunidades',
          //ESPAÑA
          'Recommendation':'Recomendação',
          'Seniority':'Antiguidade',
          'Contracting modality':'Modalidade de contratação',
          'Working':'Trabalhando',
        }
      },
      'FORALL':  {
        'MSJ_PRACTICEREGISTERED':  'Prática salva com sucesso',
        'MSJ_DESCRIPTIONREGISTERED': 'Descrição salva com sucesso',
        'MSJ_TRANSLATEREGISTERED': 'Prática traduzida com sucesso',
        'MSJ_DESCRIPTIONTRANSLATED': 'Descrição traduzida corretamente',
        'QUESTIONUPDATEDOK': 'Pergunta atualizada com sucesso',
        'QUESTIONUPDATEDFAIL': 'Erro, insira uma pergunta válida',
        'RESPONSEUPDATEDOK': 'Resposta atualizada com sucesso',
        'RESPONSEUPDATEDFAIL': 'Erro, insira um texto de resposta válido',
        'TRANSLATEDOK': 'Pergunta traduzida e salva com sucesso',
        'INSERTTRANSLATE': 'Por favor insira a tradução',
        'OPTIONTRANSLATED': 'Opção de tradução salva com sucesso',
        'INSERTOPTIONTRANSLATE': 'Por favor insira a tradução',
        'MJS_SELECTOPTION': 'Por favor selecione uma opção',
        'MJS_OPTIONADDED': 'Dados demográficos adicionados com sucesso',
        'OPTIONDELETED': 'Dados demográficos removidos com sucesso',
        'RESPONSEOPTIONDELETED': 'Resposta removida com sucesso',
        'DEMOGRAPHICEXIST': 'Dados demográficos selecionados já existem',
        'AGREGADEMOGRAFICO': 'Selecione para adicionar mais informações demográficas',
        'MSJ_PRACTICEREQUIRED': 'Prática necessária!',
        'MSJ_DESCRIPTIONREQUIRED': 'Descrição necessária!',
        'CARGANDO_PRACTICA': 'Mantendo a prática, aguarde...',
        'CARGANDO_DESCRIPCION': 'Salvando descrição, aguarde...',
        'ACTUALIZAR_OPCION': 'Atualizando resposta, aguarde...',
        'REVISANDO_PRACTICAS': 'Verificando as práticas, por favor aguarde ...',


        'SELECCIONE': 'Selecione um idioma para visualizar',
        'IDIOMAS_NOT_SELECTED': 'Nenhum idioma adicional foi selecionado',
        'TRANSLATE_NOT': 'Você precisa escrever pelo menos o nome de uma prática e sua descrição',
        'PLACEHOLDER': 'Língua',
        'DESC_TRANSLATE': 'Digite a tradução prática',
        'DESC_TRANSLATE_DEMO': 'Digite a tradução da resposta',
        'DESC_TRANSLATE_FORALL': 'Digite a tradução da descrição',
        'PRACTICE_TRANSLATE_REACTIVOS': 'Digite a tradução do reagente',
        'PRACTICE_TRANSLATE_ABIERTAS': 'Digite a tradução da pergunta em aberto',
        'PRACTICE_TRANSLATE_FORALL': 'Digite a tradução prática',
        'PRACTICE_TRANSLATE_DEMO': 'Digite a tradução demográfica',



        'IDIOMAS': {
          'Native': 'Nativo',
          'es': 'espanhol',
          'zh1': 'Chinês tradicional',
          'zh2': 'Chinês simplificado',
          'pt': 'Português',
          'en': 'Inglês',
          'vi': 'vietnamita'
        },
        'RESPUESTAS': {
          'Native': 'Nativo',
          'es':{'si': 'Sí',
          'no':'No',
          'casifalso':'Casi siempre es falso',
          'false': 'Frecuentemente es falso',
          'avecesfalse': 'A veces es falso / A veces es verdad',
          'casiverdad': 'Frecuentemente es verdad',
          'verdad': 'Casi siempre es verdad'},
          'zh1':{'si': '有','no':'沒有',
          'casifalso':'從來不是這樣',
          'false': '經常不是這樣',
          'avecesfalse': '有時是有時不是',
          'casiverdad': '經常是這樣',
          'verdad': '總是這樣'},
          'zh2':{'si': '有','no':'没有',
          'casifalso':'从来不是这样',
          'false': '经常不是这样',
          'avecesfalse': '有时是有时不是',
          'casiverdad': '经常是这样',
          'verdad': '总是这样'},
          'pt':{'si': 'Si','no':'não',
          'casifalso':'Casi siempre es falso',
          'false': 'Freqüentemente é falso',
          'avecesfalse': 'A veces es falso / A veces es verdad',
          'casiverdad': 'Freqüentemente es verdad',
          'verdad': 'Casi siempre es verdad'},
          'en':{'si': 'Yes','no':'No',
          'casifalso':'It is almost always false',
          'false': 'It is often false',
          'avecesfalse': 'Sometimes it´s fake / Sometimes it´s true',
          'casiverdad': 'It is often true',
          'verdad': 'It is almost always true'},
          'tr':{'si': 'Evet','no':'HAYIR',
          'casifalso':'Neredeyse her zaman yanlış',
          'false': 'Sık sık yanlış',
          'avecesfalse': 'Bazen doğru olmayan / bazen doğru',
          'casiverdad': 'Genellikle doğru',
          'verdad': 'Neredeyse her zaman doğru'},
          'jp':{'si': 'はい','no':'番号',
          'casifalso':'ほとんど常に当てはまらない',
          'false': 'しばしば当てはまらない',
          'avecesfalse': '時には当てはまらない／時には当てはまる',
          'casiverdad': 'しばしば当てはまる',
          'verdad': 'ほとんど常に当てはまる'}
        },
        'STATUS': {
          'PEND': 'Etapa completa',
          'DONE': 'Etapa concluída'
        },
        'TABLA': {
          'TITULOS': {
            'DEFAULT': 'Primeiro idioma',
            'TRADUCCION': 'Traduções',
            'PREVIEW': 'Pré-visualização'
          },
          'ENCABEZADOS': {
            'PRACT': 'Prática:',
            'DESCR': 'Descrição:',
            'STT1': 'Declaração 1:',
            'STT2': 'Declaração 2:',
            'LANG': 'Língua:'
          },
          'INPUTS': {
            'PRACT': 'Digite o texto da prática',
            'DESCR': 'Digite o texto da descrição'
          }
        }
      },
      'ABIERTAS': {
        'STATUS': {
          'PEND': 'Etapa completa',
          'DONE': 'Etapa concluída'
        },
        'TABS': {
          'TAB1': 'Perguntas abertas',
          'TAB2': 'Tradução',
          'TAB3': 'Pré-visualização',
        }
      },
      'ADICIONALES': {
        'FOCUS':{
          'ENVIO-AUTORIZACION':'Foi enviado para autorização',
          'AUTORIZACION-OK':'Sua pesquisa foi autorizada, prossiga para concluir a etapa',

        },
        'STATUS': {
          'PEND': 'Etapa completa',
          'DONE': 'Etapa concluída'
        },
        'TABS': {
          'QUESTIONS': 'Questões adicionais',
          'TRANSLATE': 'Traduções',
          'PREVIEW': 'Pré-visualização'
        },
        'PREGUNTAS':{
          'STATUS': {
            'SIN': 'Você não criou perguntas adicionais',
            'CON': 'Perguntas criadas:',
            'NOADICIONALES': 'A opção foi escolhida sem perguntas adicionais',
            'CANCELNOADIC': 'Opção cancelada sem perguntas adicionais',
            'ERROR': 'Ocorreu um erro ao executar a operação'
          },
          'ACCIONES': {
            'ADD': 'Criar uma pergunta:',
            'SIN': 'Não adicione perguntas adicionais à pesquisa'
          },
          'WIZARD': {
            'NEW': 'Nova pergunta',
            'TIPOTITU': 'Clique aqui para configurar a pergunta adicional',
            'TIPO': {
              'OPEN': 'Questão aberta',
              'UNI': 'Questão de uma opção',
              'MULT': 'Pergunta de múltipla escolha',
              'MULTLIKERT3-1': 'Pergunta na escala Likert 3',
              'MULTLIKERT5-1': 'Pergunta na escala Likert de 5',
              'MULTLIKERT-MUL': 'Pergunta em escala Likert Múltipla',
            },
            'FORM': {
              'TIPO': 'Tipo de pergunta:',
              'TOOLTIP': {
                'REMOVE': 'Remover esta pergunta'
              },
              'MENSAJES': {
                'BORRAR': 'Deseja excluir esta pergunta adicional?',
                'PREG_OK': 'A pergunta foi armazenada com sucesso',
                'PREG_ERR': 'Ocorreu um erro ao armazenar a pergunta',
                'PREG_MOD_OK': 'A pergunta foi modificada com sucesso',
                'PREG_MOD_ERR': 'Ocorreu um erro ao modificar a pergunta',
                'OPC_OK': 'A opção de resposta foi armazenada com sucesso',
                'OPC_ERR': 'Ocorreu um erro ao armazenar a opção de resposta',
                'OPC_MOD_OK': 'A opção de resposta foi modificada com sucesso',
                'OPC_MOD_ERR': 'Ocorreu um erro ao modificar a opção de resposta',
                'PREG_DEL_OK': 'A questão foi removida com sucesso',
                'PREG_DEL_ERR': 'Ocorreu um erro ao excluir a pergunta',
                'OPC_DEL_OK': 'A opção de resposta foi removida com sucesso',
                'OPC_DEL_ERR': 'Ocorreu um erro ao remover a opção de resposta'
              },
              'BOTONES':{
                'SI': 'sim',
                'NO': 'Não'
              }
            },
            'ABIERTA': {
              'TITULO': 'Nova pergunta em aberto:',
              'ACCION': 'Digite o texto da pergunta:',
              'ERROR': 'Você não inseriu o texto da pergunta'
            },
            'MULTI':{
              'TITULOSING': 'Nova pergunta de uma opção:',
              'TITULOMULT': 'Nova pergunta de múltipla escolha:',
              'TITULOLIKERT3': 'Nova pergunta à escala de likert: 3',
              'TITULOLIKERT5': 'Nova pergunta à escala de likert: 5',
              'TITULOLIKERTSIMPLE': 'Nova questão simples em escala de likert',
              'ACCION': 'Digite o texto da pergunta:',
              'ERROR': 'Você não inseriu o texto da pergunta',
              'MENSAJES': {
                'BORRAR': 'Deseja excluir esta opção de resposta?',
                'SINPREG': 'Você não pode inserir opções até inserir o texto da pergunta',
                'SINANTE': 'Você não pode inserir o texto desta opção até inserir o texto da opção anterior',
                'WARN-2-1 ':' Você só pode inserir 2 opções de resposta ',
                'WARN-3-1 ':' Você só pode inserir 3 opções de resposta ',
                'WARN-5-1 ':' Você só pode inserir 5 opções de resposta ',
                'WARN-NO-NUMBER': 'Você só pode inserir números',
                'ETIQUET-VALOR':'Valor',
              },
              'OPCIONES': {
                'TITU': 'Opções de resposta',
                'INPUT': {
                  'TITU': 'Opção de resposta',
                  'ERROR': 'Você não inseriu o texto da opção de resposta'
                }
              },
              'TOOLTIP': {
                'ADD': 'Adicionar uma opção de resposta:',
                'MOVE': 'Mover opção de resposta',
                'REMOVE': 'Remova esta opção de resposta'
              }
            }
          }
        },
        'TRADUCCIONES': {
          'TITULO': 'Selecione um idioma para inserir os textos de tradução',
          'TITULOALTERNO': 'Você não selecionou idiomas adicionais na seção "Idiomas"',
          'NOTYET': 'Tradução ainda não concluída',
          'MAIN': 'Primeiro idioma',
          'INPUT': {
            'NEW': 'Digite a tradução do reagente',
            'ERROR': 'Você não inseriu o texto da tradução!',
            'NEWOPC': 'Digite a tradução da opção de resposta',
            'ERROROPC': 'Você não inseriu o texto da tradução!'
          },
          'MENSAJES': {
            'PREG_OK': 'O texto da tradução foi armazenado corretamente',
            'PREG_ERR': 'Ocorreu um erro ao armazenar o texto da tradução',
            'PREG_MOD_OK': 'O texto da tradução foi atualizado corretamente',
            'PREG_MOD_ERR': 'Ocorreu um erro ao atualizar o texto da tradução',
            'OPC_NOPREG': 'Não é possível armazenar o texto da tradução da opção de resposta sem inserir o texto da pergunta.',
            'OPC_OK': 'O texto da tradução foi armazenado corretamente',
            'OPC_ERR': 'Ocorreu um erro ao armazenar o texto da tradução',
            'OPC_MOD_OK': 'O texto da tradução foi atualizado corretamente',
            'OPC_MOD_ERR': 'Ocorreu um erro ao atualizar o texto da tradução',

            'TRADUC_PREGUNT':'A tradução da pergunta está a ser salva...',
            'TRADUC_MOD_PREGUNT':'A tradução da pergunta está a ser actualizada...',
            'TRADUC_OPC':'A tradução da opção está a ser guardada...',
            'TRADUC_MOD_OPC':'A tradução da opção está a ser actualizada...',
            'VALOR_OK':'O valor da opção foi guardado correctamente',
            'VALOR_MOD_OK':'O valor da opção foi actualizado correctamente',
          },
          'COMPLETE': 'Tradução completa'
        },
        'PREVIEW': {
          'TITULO': 'Selecione um idioma para exibir traduções de perguntas adicionais',
          'SINPREV': 'Não há textos traduzidos para o idioma selecionado',
          'LOADING': 'Carregando dados...',
          'INPUT': {
            'RESPABIERTA': 'Escreva sua resposta:',
            'ERRORABIERTA': 'Você não escreveu sua resposta!',
            'ELIGELANG': 'Escolha um idioma'
          },
          'HELP': {
            'SINGLE': 'Você pode escolher apenas uma opção nesta pergunta',
            'MULTI': 'Você pode escolher mais de uma opção nesta pergunta',
            'FALTA': 'O texto da tradução não foi inserido! '
          }
        }
      },
      'COLABORADORES': {
        'STATUS': {
          'PEND': 'Etapa completa',
          'DONE': 'Etapa concluída'
        },

        'STATUSBAR': {
          'NOBD': 'Você não carregou a lista de colaboradores',
          'PROCES': 'A lista de colaboradores ainda não foi armazenada',
          'ERROR': 'Erros encontrados no arquivo',
          'OK': 'A lista de colaboradores está armazenada corretamente',
        },
        'CARD_BD': {
          'TITULO': 'em formação: ',
          'NUMCOLABS': 'Número de colaboradores: ',
          'FECHA': 'Data do último upload: ',
          'TITULO_PRE': 'Histórico de upload:',
          'TITULO_PRE_2': 'Usuarios',
          'ACCIONES': 'Ações: ',
          'WANNADO': 'O que você quer fazer?',
          'BOTONES': {
            'DESCARGA': 'Baixe a lista de colaboradores',
            'ELIMINA': 'Excluir a lista',
            'VER': 'Veja a lista de participantes'
          }
        },
        'CARD_NOBD': {
          'TITULO': 'Siga estas etapas para enviar as informações do seu colaborador para CULTURAL GO®',
          'PASOS': {
            '1': 'Baixe o modelo de lista de parceiros',
            '2': 'Preencha o modelo com as informações de seus colaboradores com base nas colunas fornecidas',
            '3': 'Carregue o arquivo com as informações de seus colaboradores',
          },
          'TOOLTIP': 'Este arquivo possui macros de validação de dados',
          'FILE': 'Arquivo de modelo da lista de colaboradores'
        },

        'CARD_NOERR': {
          'TITULO': 'em formação',
          'NUMCOLABS': 'Número de colaboradores no arquivo: ',
          'FILENAME': 'nome do arquivo: ',
          'GUARDAR': 'Deseja armazenar esta informação?',
          'BOTONES': {
            'SI': 'sim',
            'NO': 'Não'
          }
        },
        'CARD_ERRFND': {
          'TITULO': 'em formação: ',
          'ROWS_OK': 'Número de linhas corretas: ',
          'MOREINFO': '* A lista de erros é mostrada em detalhes abaixo',
          'ROWS_NOTOK': 'Número de linhas com erros: ',
          'GUARDAR': 'As informações carregadas não podem ser armazenadas',
          'DELETE': 'Excluir arquivo',
          'FILENAME': 'nome do arquivo: ',
        },
        'CARD_ERRLIST': {
          'TITULO': {
            '1': 'Linhas com erros: ',
            '2': 'Total de erros encontrados: '
          },
          'INFO': {
            'ROW': 'Linha: ',
            'SHOW': 'Clique aqui para ver os erros nesta linha',
            'ERRNUM': 'Número de erros: ',
          },
          'DETALLE': {
            'TIPO': 'Tipo de erro: ',
            'DESCR': 'Descrição: ',
            'COLUMNA': 'Coluna: ',
            'DATO': 'Dados errados: '
          },

          'ERRORES': {
            'alfabetica': 'Invalidez alfabética',
            'alfanumerica': 'Invalidez alfanumérica',
            'numerica': 'Invalidez numérica',
            'email': 'Invalidez por e-mail',
            'vacio': 'Célula vazia',
            'columna': 'coluna desconhecida',
            'catSurvey': 'Informação desconhecida',
            'repetido': 'Informações repetidas',
            'clavenumerica':'Invalidez da chave',
            'sameKey': 'A mesma chave do chefe',
            'noCeo': 'CEO não encontrado',
            'bosskeyNotFnd': 'A chave do chefe não existe',
            'continuidad': 'Continuidade em níveis',
            'nivelRepetido': 'Informação repetida',
            'multiceo': 'CEO múltiplo',
            'age': 'Ano de nascimento errado',
            'seccionSinUsar': 'Chave de seção especial não usada',
            'date': 'Formato de data inválido',
            'listOption': 'Informações incorretas',
            'dateFuture': 'Data não permitida'
          },

          'DESCRIPCION': {
            'alfabetica': 'As informações contêm um ou mais caracteres ilegais. Apenas caracteres alfabéticos (A - Z) e os seguintes caracteres especiais são permitidos: (). ,: -',
            'alfanumerica': 'As informações contêm um ou mais caracteres ilegais. Apenas caracteres alfabéticos (A - Z), caracteres numéricos (0 - 9) e os seguintes caracteres especiais são permitidos: (). ,: -',
            'numerica': 'As informações contêm um ou mais caracteres ilegais. Somente caracteres numéricos são permitidos (0 - 9)',
            'email': 'As informações não têm a sintaxe correta (mail@domain.com)',
            'vacio': 'A célula não possui informações. Esta coluna é obrigatória',
            'columna': 'A coluna não pertence ao modelo fornecido pelo CULTURAL GO®',
            'catSurvey': 'As informações na célula não correspondem a nenhuma das opções inseridas na seção Informações demográficas da plataforma',
            'repetido': 'A célula contém informações repetidas em outra célula na mesma coluna. Dados repetidos não são permitidos nesta coluna.',
            'sameKey': 'A linha contém a mesma chave nas colunas \'Chave do colaborador \' e \'Chave direta do chefe \', isso não é permitido',
            'noCeo': 'As informações do CEO não foram encontradas na lista de colaboradores, devem ser especificadas com a senha do colaborador \'0\' para continuar',
            'bosskeyNotFnd': 'A chave do chefe especificada nesta célula não foi encontrada associada a nenhum colaborador da lista',
            'continuidad': 'A continuidade dos níveis nesta célula foi interrompida, os níveis devem ser contínuos',
            'nivelRepetido': 'A informação nesta célula foi repetida com a correspondente ao nível anterior, isto não é permitido',
            'multiceo': 'Foi encontrado mais de um colaborador indicado como CEO, só é permitido ter um colaborador indicado como CEO no arquivo ',
            'age': 'O ano de nascimento informado deve ter quatro dígitos',
            'seccionSinUsar': 'Foi encontrada pelo menos uma chave de seção especial que não constava da lista de colaboradores. Todas as chaves de seções especiais devem ser usadas por pelo menos um colaborador',
            'date': 'As informações inseridas não têm o formato de data correto',
            'listOption': 'As informações inseridas não correspondem a nenhuma das opções fornecidas pelo modelo. Apenas uma das opções padrão é permitida nesta célula',
            'dateFuture': 'A data inserida na célula corresponde a uma data posterior ao dia atual. Só é permitido inserir uma data anterior ao dia atual'
          }
        },
        'CARD_LOAD': {
          'CARGA': {
            'TITULO': 'Carregando...',
            'INFO': 'Analisando as informações do arquivo, aguarde um momento'
          },
          'GUARDA': {
            'TITULO': 'Salvando...',
            'INFO': 'Armazenando as informações no sistema, permaneça nesta tela até o processo terminar'
          },
        },
        'MENSAJES': {
          'GUARDA_1': 'Confirme para armazenar as informações de ',
          'GUARDA_2': ' colaboradores?',
          'GUARDADO': 'A lista de colaboradores foi armazenada corretamente',
          'GUA_ERR': 'Ocorreu um erro ao armazenar as informações. Por favor, tente novamente mais tarde',
          'NODELETE':'Você não pode deletar a base de dados se os e-mails foram enviados para seus colaboradores',
          'DELETE_1': 'Confirme para excluir as informações de ',
          'DELETE_2': ' colaboradores?',
          'DEL_OK_1': 'Eles foram removidos com sucesso ',
          'DEL_OK_2': ' colaboradores',
          'DEL_ERR': 'Ocorreu um erro ao excluir a lista de colaboradores. Por favor, tente novamente mais tarde',
          'DEL_ERR_EMA_SEN': 'Esta acção não é possível porque os e-mails foram enviados',
          'DELFILE': 'A lista carregada foi removida com sucesso',
          'EXCEL': 'Gerando arquivo excel, aguarde um momento',
          'EXTMAL': 'O arquivo selecionado não está no formato correto. Somente upload de arquivo fornecido por CULTURAL GO®',
          'NOROWS': 'O arquivo selecionado não possui registro',
          'VACIO': 'O arquivo selecionado está vazio ou as informações não podem ser encontradas na primeira folha',
          'VERSIONANTERIOR': 'O arquivo selecionado corresponde a uma versão anterior da lista de colaboradores, baixe a versão mais recente, carregue as informações de seus colaboradores naquele arquivo e carregue novamente a lista',
          'BROKERINCORRECTO': 'O arquivo selecionado não corresponde à versão da corretora a que pertence a empresa, baixe novamente o template, carregue as informações de seus colaboradores naquele arquivo e carregue novamente a lista',
          'BOTONES': {
            'SI': 'sim',
            'NO': 'Não'
          }
        },
        'EXCELINFO': {
          'HOJA': 'Dados dos colaboradores',
          'TITULO': 'Lista de colaboradores',
          'AUTOR': 'CULTURAL GO®',
          'ASUNTO': 'Transferido da plataforma'
        },
        'UPLOAD': 'Clique aqui para pesquisar a lista de colaboradores',
        'REMOVE': 'Remover da carga',
        'SEND': 'Enviar para a lista',
        'PROCESO': {
          'STP1': 'Analisando a lista de colaboradores',
          'STP2': 'Salvando a lista de colaboradores'
        },
        'ALERT_COLAB':'Os usuários serão refletidos na pesquisa assim que esta etapa for marcada como concluída',
        'MODAL_ERROR': {
          'TITULO': 'Erros encontrados no arquivo',
          'TOTAL_ERRORES_1': 'Erros encontrados no arquivo',
          'TOTAL_ERRORES_2': 'Encontrou <b> mais de 100 </b> erros no arquivo',
          'INFO_1': 'A quantidade e o tipo de erros específicos são mostrados em detalhes abaixo',
          'INFO_2': '<b> NOTA: </b> o processo só pode continuar se o arquivo não tiver erros, ao fechar esta janela o processo será reiniciado. Faça as correções necessárias no arquivo e recarregue-o',
          'TABLA_RESUMEN': {
            'TIPO': 'Tipo de erro',
            'TOTAL': 'Total de erros',
            'ACCIONES': 'Ações',
            'MASINFO': 'Mais Informações',
            'VERMAS': 'Ver erros'
          },
          'TABLA_LISTA': {
            'TOTAL_1': 'Erros exibidos',
            'TOTAL_2': 'Erros não exibidos',
            'INFO': 'Os erros não mostrados são semelhantes em características aos mostrados',
            'FILA': 'Linha',
            'COLUMNA': 'Coluna',
            'DATO': 'Dados errados'
          },
          'BOTONES': {
            'REGRESAR': 'Volte',
            'CONTINUAR': 'Prosseguir'
          }
        }
      }
    }
  }
};
